import { EVENTS } from 'src/constants/webSocketConsts/events';
import {
  deleteSubscriptionsAction,
  updateSubscriptionsAction,
} from 'src/store/payments/actions';

const subscriptionHandler = (event: string, items: Array<any>) => {
  if (items.length === 0) {
    return null;
  }
  switch (event) {
    case EVENTS.REMOVE:
      return deleteSubscriptionsAction(items);
    case EVENTS.INSERT:
    case EVENTS.MODIFY:
      return updateSubscriptionsAction(items);
    default:
      break;
  }
  return null;
};

export default subscriptionHandler;
